<template>
  <div class="">getting token for this : {{ code }}</div>
</template>

<script>
import apiClient from "@/core/buildRequest";

export default {
  name: "TiktokRedirectView",
  data() {
    return {
      code: "",
    };
  },
  mounted() {
    this.getTiktokChatToken();
  },
  methods: {
    getTiktokChatToken() {
      const code = this.$route.query.code;
      this.code = this.$route.query.code;

      if (code) {
        const body = {
          code: code,
          userId: JSON.parse(localStorage.getItem("user")).data.id,
        };
        apiClient
          .post("/auth/tiktok/callback", body)
          .then((response) => {

            const access_token = response.data.data.access_token;


            localStorage.setItem("tiktok_token", access_token);
            this.$router.push({ name: "integrations" });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.error("OAuth code not found in query parameters.");
      }
    },
  },
};
</script>
